/** plural(1,'page') → "1 page"; plural(3,'category','categories') → "3 categories". */
export function plural(count, singular, pluralForm) {
    const n = Number(count) || 0;
    const word = n === 1 ? singular : (pluralForm || `${singular}s`);
    return `${n} ${word}`;
}

export default plural;
